// src/components/OurVisionSection.jsx
import React from "react";

const visionPoints = [
  {
    number: 1,
    title: "Strategic Partnership",
    description:
      "We work hand-in-hand with clients to understand unique challenges and goals, providing solutions that anticipate future opportunities and trends.",
  },
  {
    number: 2,
    title: "Innovative Solutions",
    description:
      "Our team leverages cutting-edge technologies, AI-based assistants, and automation to enhance efficiency, streamline processes, and drive digital transformation.",
  },
  {
    number: 3,
    title: "Proven Experience",
    description:
      "Founded in 2023, we’ve evolved from small college projects to delivering large-scale, tailored solutions for clients like Rotaract, CSI, IEEE, and IET, showcasing practical expertise in web and software development.",
  },
];

const VisionPointCard = ({ number, title, description }) => (
  <div className={`p-4 sm:p-6 md:p-4 lg:p-6 border-l border-black/50`}>
    <div className="flex items-center space-x-3 mb-3 sm:mb-4">
      <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gray-900 flex items-center justify-center text-white font-bold text-sm sm:text-base">
        {number}
      </div>
      <h3 className="text-lg sm:text-xl md:text-lg lg:text-xl font-semibold text-gray-900">
        {title}
      </h3>
    </div>
    <p className="text-sm sm:text-base md:text-sm lg:text-base text-gray-600 leading-relaxed">
      {description}
    </p>
  </div>
);

const OurVisionSection = () => {
  return (
    <section className="py-16 sm:py-20 md:py-24 bg-gray-50 font-sans">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-4xl pb-12 sm:pb-16">
          <span className="text-sm sm:text-base font-medium border border-gray-200 rounded-full px-2 py-1 text-gray-600 mb-2 sm:mb-4 inline-block">
            Our Vision & Mission
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-snug sm:leading-tight md:leading-tight text-gray-900">
            Empowering businesses with innovative solutions and strategic
            insights to drive sustainable growth and digital transformation.
          </h2>
        </div>

        {/* Mission Text */}
        <div className="max-w-4xl mb-12 sm:mb-16 space-y-4">
          <p className="text-base sm:text-lg md:text-base lg:text-lg text-gray-700 leading-relaxed">
            Riff Raff Tech Solutions is more than an IT service provider; we are
            a strategic partner committed to delivering scalable solutions that
            enhance efficiency, optimize processes, and inspire digital growth.
          </p>
          <p className="text-base sm:text-lg md:text-base lg:text-lg text-gray-700 leading-relaxed">
            Our expertise spans software development, cloud computing,
            cybersecurity, and data analytics, ensuring clients are equipped to
            thrive in an evolving digital landscape.
          </p>
        </div>

        {/* Three Pillars Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 md:gap-6 lg:gap-8 pt-8">
          {visionPoints.map((point) => (
            <VisionPointCard key={point.number} {...point} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurVisionSection;
